module.exports = __webpack_public_path__ + "img/dark-green-rectangle-table-8.7fe8df5c.png";